import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useVaults } from "hooks/useVaults";
import { NextSeo } from "next-seo";
import React, { useCallback, useEffect, useState } from "react";
import { MintRepayView } from "views/mint/MintRepayView";
import { Container, Footer, Header } from "../components";
var Main = function() {
    var vaults = useVaults().vaults;
    var ref = useState(false), showGlitch = ref[0], setShowGlitch = ref[1];
    var showGlitchRandom = useCallback(function() {
        var duration = Math.round(Math.random() * 5 + 5) * 1000;
        var startTimeoutId = setTimeout(function() {
            setShowGlitch(true);
        }, duration);
        var endTimeoutId = setTimeout(function() {
            setShowGlitch(false);
        }, duration + 3000);
        return {
            startTimeoutId: startTimeoutId,
            endTimeoutId: endTimeoutId
        };
    }, []);
    useEffect(function() {
        var startTimeoutId;
        var endTimeoutId;
        var result = showGlitchRandom();
        var intervalId = setInterval(function() {
            result = showGlitchRandom();
            startTimeoutId = result.startTimeoutId;
            endTimeoutId = result.endTimeoutId;
        }, 60000);
        return function() {
            clearTimeout(startTimeoutId);
            clearTimeout(endTimeoutId);
            clearInterval(intervalId);
        };
    }, []);
    return /*#__PURE__*/ _jsxs("main", {
        className: "flex flex-col flex-1 items-center sm:justify-center pt-4 sm:py-6",
        children: [
            /*#__PURE__*/ _jsx("div", {
                className: "flex flex-row justify-between sm:w-card w-full overflow-hidden sm:pt-2 relative",
                children: /*#__PURE__*/ _jsx("div", {
                    className: "sm:ml-52 sm:mb-6 mb-4"
                })
            }),
            /*#__PURE__*/ _jsx("div", {
                className: "bg-default shadow px-3 py-4 sm:p-8 overflow-hidden sm:w-card w-full rounded-3xl rounded-b-none sm:rounded-b-3xl",
                children: /*#__PURE__*/ _jsx(MintRepayView, {
                    vault: vaults[0],
                    initialView: "mint"
                })
            })
        ]
    });
};
var Page = function() {
    return /*#__PURE__*/ _jsxs(Container, {
        children: [
            /*#__PURE__*/ _jsx(NextSeo, {
                title: "Mint"
            }),
            /*#__PURE__*/ _jsx(Header, {}),
            /*#__PURE__*/ _jsx(Main, {}),
            /*#__PURE__*/ _jsx(Footer, {})
        ]
    });
};
export default Page;
